import {API} from 'api';

const upvoteContent = async (url: string, vote: VoteType) => {
  const response = await API.post(url, {vote});
  return response.vote as VoteType;
};

const upvoteQuestion = async (slug: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/questions/${slug}`, vote);
};

const upvoteSolution = async (uuid: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/solutions/${uuid}`, vote);
};

const upvoteComment = async (uuid: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/comments/${uuid}`, vote);
};

const upvotePost = async (uuid: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/posts/${uuid}`, vote);
};

const upvoteCourseSection = async (uuid: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/course-sections/${uuid}`, vote);
};

const upvoteTakehomeSubmission = async (uuid: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/takehome-submissions/${uuid}`, vote);
};

const upvoteTakehome = async (uuid: string, vote: VoteType) => {
  return upvoteContent(`/v1/content-upvotes/takehome/${uuid}`, vote);
};

export const ContentUpvotesAPI = {
  upvoteQuestion,
  upvoteSolution,
  upvoteComment,
  upvotePost,
  upvoteCourseSection,
  upvoteTakehome,
  upvoteTakehomeSubmission,
};
